/**
 * `m:ss` for a media length — the single implementation; `getRecordedTime` and
 * `getRecordTime` delegate here (TRE-1784).
 *
 * Mind the unit. `FileMessageContent.duration` is NOT one unit: audio attachments store
 * seconds (4451 rows in production, max 1104) and video attachments store milliseconds
 * (684 rows, max 229 657 — the same 230 s clip). Whoever reads that field has to know
 * which content type it belongs to, hence two entry points here rather than a guess.
 *
 * Rounds before splitting, so a fractional duration cannot render as "1:18.699999999",
 * and grows an hours slot rather than reporting an hour and three seconds as "60:03".
 * Nothing in production is anywhere near that today — the longest chat audio is 18:24 and
 * the longest video 3:50 — but the minute-only form would have been silently wrong the
 * first time someone sent a long recording.
 */
export const formatMediaDurationFromSeconds = (durationSeconds: number): string => {
  const total = Math.round(durationSeconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }

  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

export const formatMediaDuration = (durationMs: number): string => formatMediaDurationFromSeconds(durationMs / 1000);
